import { Grid, GridItem, Skeleton } from '@gusto/workbench';

export default function LoadingSkeleton() {
  return (
    <div aria-busy className="width-100 col-12 col-xxl-9 padding-none">
      <Grid autoRows="max-content" rowGap={4} marginBottom={8}>
        <GridItem>
          <Skeleton height={80} />
        </GridItem>
        <GridItem>
          <Skeleton height={500} borderRadius={4} />
        </GridItem>
        <GridItem>
          <Skeleton height={50} />
        </GridItem>
      </Grid>
    </div>
  );
}
